import { __assign, __rest } from "tslib";
// DS: DS2.6
import React from 'react';
import c from 'classnames';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import SimpleTooltip from '@wix/da-ds/pkg/tooltips/dsPreset/SimpleTooltip';
import ConditionalWrapper from '../ConditionalWrapper';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import s from './ToggleButton.scss';
var ToggleButton = function (_a) {
    var tooltipText = _a.tooltipText, activated = _a.activated, disabled = _a.disabled, Icon = _a.icon, iconRef = _a.iconRef, label = _a.label, className = _a.className, rest = __rest(_a, ["tooltipText", "activated", "disabled", "icon", "iconRef", "label", "className"]);
    return (React.createElement(ConditionalWrapper, { condition: tooltipText !== undefined, wrap: function (child) { return (React.createElement(SimpleTooltip, { text: tooltipText, placement: "top" }, child)); } },
        React.createElement(PlainButtonOrLink, __assign({ className: c(s['root'], activated && s['on'], disabled && s['disabled'], className), disabled: disabled }, rest),
            React.createElement(Icon, { className: s['icon'], size: IconSize.MEDIUM, disableDefaultColors: true, containerRef: iconRef }),
            label && React.createElement("span", { className: s['label'] }, label))));
};
ToggleButton.displayName = 'ToggleButton';
export default ToggleButton;
//# sourceMappingURL=ToggleButton.js.map